/* eslint-disable */
import auth, { get, post, executeLongJob, getLocale, getQuantityLabel2, confirmDialog, _log } from "./auth";
import { resultHandler, getMenuItem, getMenuCategory, allergens, getMenuItemAdmin, getMenuCategoryAdmin } from "./admin";
import { I18n } from "react-redux-i18n";
import menuitemutil from "./admin/menuitem";
import admin from "./admin";


var utils = {};

utils.getMenuItems = function (handler) {
  get("adminService/" + localStorage.restaurantSelected + "/getMenuItems", localStorage.restaurantSelected).done(function (data) {
    if (data == null) {
      console.log("Failed to get meal categories!");
    } else {
      handler(data);
    }
  });
};

utils.getOrder = function (tableOccupation, order, handler) {
  get("adminService/" + localStorage.restaurantSelected + "/getOrder?tableOccupation=" + tableOccupation + "&drinkOrder=" + order + "&lang=" + localStorage.language, localStorage.restaurantSelected).done(function (data) {
    if (data == null) {
      console.log("Failed to get drink orders!");
    } else {
      handler(data);
    }
  });
};

utils.activateMenuCategory = function (id, active, handler, errorHandler) {
  get("adminService/" + localStorage.restaurantSelected + "/activateMenuCategory/" + id + "?active=" + active).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
};

utils.activateMenuItem = function (id, active, handler, errorHandler) {
  get("adminService/" + localStorage.restaurantSelected + "/activateMenuItem/" + id + "?active=" + active).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
};

utils.recalculateConsumption = function (id, quantity, from = "", handler, errorHandler, readOnlyValidation = false) {
  let query = "adminService/" + localStorage.restaurantSelected + "/recalculateConsumption?menuitem=" + id + "&quantity=" + quantity + "&lang=" + localStorage.language;
  if (from !== "" && from != null) {
    query += "&from=" + from;
  }
  if (readOnlyValidation) {
    query += "&readonly=true";
  }
  executeLongJob(
    I18n.t("admin_local.recalculateConsumption") + ": " + getLocale(getMenuItem(id).name) + " " + getQuantityLabel2(getMenuItem(id).entityType, quantity, getMenuItem(id).quantityType),
    query,
    false
  ).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
};

utils.modifyMenuItemAvailabilty = (id, available, handler, errorHandler) => {
  get("orderService/" + localStorage.restaurantSelected + "/modifyMenuItemAvailability/" + id + "/" + available).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
}
utils.modifyMenuItemsAvailabilty = (ids, available, handler, errorHandler) => {
  _log("modifyMenuItemsAvailabilty");
  post("orderService/" + localStorage.restaurantSelected + "/modifyMenuItemAvailability/" + available, ids).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
}
utils.modifyMenuCategoryAvailabilty = (id, available, handler, errorHandler) => {
  get("orderService/" + localStorage.restaurantSelected + "/modifyMenuCategoryAvailability/" + id + "/" + available).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
}
utils.modifyMenuItemActivity = (id, available, handler, errorHandler) => {
  get("orderService/" + localStorage.restaurantSelected + "/modifyMenuItemActivity/" + id + "/" + available).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
}
utils.modifyMenuCategoryActivity = (id, available, handler, errorHandler) => {
  get("orderService/" + localStorage.restaurantSelected + "/modifyMenuCategoryActivity/" + id + "/" + available).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
}
utils.modifyMenuItemPos = (id, pos, handler, errorHandler) => {
  get("orderService/" + localStorage.restaurantSelected + "/modifyMenuItemPos/" + id + "/" + pos).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
}
utils.modifyMenuCategoryPos = (id, pos, handler, errorHandler) => {
  get("orderService/" + localStorage.restaurantSelected + "/modifyMenuCategoryPos/" + id + "/" + pos).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
}
function modifyMenuItem(
  parentCategoryId,
  {
    entityType,
    id,
    globalId,
    barcodes,
    action,
    shortName,
    manufacturer,
    name,
    description,
    image,
    bigImage,
    quantityType,
    cost,
    unitPrice,
    availableQuantities,
    timing,
    productionLines,
    vatCategory,
    takeawayVatCategory,
    isActive,
    isTop,
    pos,
    kiosk,
    above18,
    online,
    available,
    inventoryItem,
    freeQuantity,
    menuItemAdditions,
    menuCategoryAdditions,
    labels,
    pricePerCostRatio,
    color,
    mandatory_volume,
    places,
    preorder,
    toDate,
    fromDate,
    mainCategory,
    subCategory,
    mainCategoryId,
    subCategoryId,
    woltImage,
    foodpandaImage,
    falatozzImage,
    choiceqrImage,
    minimumPrice,
    allergens,
    removable_allergens,
    calorie,
    approvedCost
  },
  handler,
  errorHandler,
  recalculateInventory = false
) {
  var production_lines_q = "";
  productionLines.forEach(function (pl) {
    production_lines_q += "&productionLineId=" + (pl.id ? pl.id : pl);
  });
  menuItemAdditions && menuItemAdditions.forEach(function (a) {
    if (a.type == "meal_addition") a.addition.type = "meal";
    else a.addition.type = "drink";
  });
  menuCategoryAdditions && menuCategoryAdditions.forEach(function (a) {
    if (a.type == "mealcategory_addition") a.addition.type = "mealcategory";
    else a.addition.type = "drinkcategory";
  });
  availableQuantities.forEach(q => {
    delete q.selected;
    if (!q.inventoryItem)
      q.cost = 0;
  });
  var entityType = menuitemutil.getMenuItem(id).entityType;
  vatCategory = vatCategory && vatCategory.id ? vatCategory.id : 0;
  takeawayVatCategory = takeawayVatCategory && takeawayVatCategory.id ? takeawayVatCategory.id : 0;
  executeLongJob(
    "",
    "adminService/" + localStorage.restaurantSelected + "/modify" + entityType + "/" + parentCategoryId + "/" + id + "?" + production_lines_q + "&vatCategoryId=" + vatCategory + "&takeawayVatCategoryId=" + takeawayVatCategory + "&action=" + action + "&recalculateInventory=" + recalculateInventory,
    false,
    {
      type: (entityType || menuitemutil.entityType).toLowerCase(),
      id: id,
      globalId,
      barcodes: barcodes,
      shortName: shortName,
      manufacturer: manufacturer,
      name: name,
      description: description,
      imageSrc: image,
      bigImageSrc: bigImage,
      quantityType: quantityType,
      cost: cost,
      unitPrice: unitPrice,
      availableQuantities: availableQuantities,
      timing: timing,
      isActive: isActive,
      isTop: isTop,
      pos: pos,
      kiosk: kiosk,
      above18,
      online: online,
      available: available,
      inventoryItem: inventoryItem,
      freeQuantity: freeQuantity,
      menuItemAdditions: menuItemAdditions,
      menuCategoryAdditions: menuCategoryAdditions,
      labels: labels,
      pricePerCostRatio: pricePerCostRatio,
      color: color,
      mandatory_volume: mandatory_volume,
      settings: places,
      preorder,
      toDate,
      fromDate,
      mainCategory: mainCategory === undefined ? mainCategoryId : mainCategory,
      subCategory: subCategory === undefined ? subCategoryId : subCategory,
      woltImageSrc: woltImage,
      foodpandaImageSrc: foodpandaImage,
      falatozzImageSrc: falatozzImage,
      choiceqrImageSrc: choiceqrImage,
      minimumPrice,
      allergens,
      removable_allergens,
      calorie,
      approvedCost,
      priceModification: null
    }
  ).done(function (data) {
    auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
    resultHandler(data, handler, errorHandler);
  });
}
utils.modifyMenuItem = modifyMenuItem;

function addMenuItem(
  parentCategoryId,
  {
    globalId,
    barcodes,
    shortName,
    manufacturer,
    name,
    description,
    image,
    bigImage,
    quantityType,
    cost,
    unitPrice,
    availableQuantities,
    timing,
    productionLines,
    vatCategory,
    takeawayVatCategory,
    isActive,
    isTop,
    pos,
    kiosk,
    above18,
    online,
    available,
    inventoryItem,
    freeQuantity,
    menuItemAdditions,
    menuCategoryAdditions,
    labels,
    pricePerCostRatio,
    color,
    mandatory_volume,
    places,
    preorder,
    toDate,
    fromDate,
    mainCategory,
    subCategory,
    woltImage,
    foodpandaImage,
    falatozzImage,
    choiceqrImage,
    minimumPrice,
    allergens,
    removable_allergens,
    calorie,
    approvedCost
  },
  handler,
  errorHandler
) {
  var production_lines_q = "";
  productionLines.forEach(function (pl) {
    production_lines_q += "&productionLineId=" + (pl.id ? pl.id : pl);
  });
  vatCategory = vatCategory.id ? vatCategory.id : vatCategory;
  takeawayVatCategory = takeawayVatCategory && takeawayVatCategory.id ? takeawayVatCategory.id : takeawayVatCategory;
  post("adminService/" + localStorage.restaurantSelected + "/add" + menuitemutil.entityType + "/" + parentCategoryId + "?" + production_lines_q + "&vatCategoryId=" + vatCategory + "&takeawayVatCategoryId=" + takeawayVatCategory, {
    globalId,
    barcodes: barcodes,
    type: menuitemutil.entitytype,
    shortName: shortName,
    manufacturer: manufacturer,
    name: name,
    description: description,
    imageSrc: image,
    bigImageSrc: bigImage,
    quantityType: quantityType,
    cost: cost,
    unitPrice: unitPrice,
    availableQuantities: availableQuantities,
    timing: timing,
    isActive: isActive,
    isTop: isTop,
    pos,
    kiosk: kiosk,
    above18,
    online: online,
    available: available,
    inventoryItem: inventoryItem,
    freeQuantity: freeQuantity,
    menuItemAdditions: menuItemAdditions,
    menuCategoryAdditions: menuCategoryAdditions,
    labels: labels,
    pricePerCostRatio: pricePerCostRatio,
    color: color,
    mandatory_volume: mandatory_volume,
    settings: places,
    preorder,
    toDate,
    fromDate,
    mainCategory,
    subCategory,
    woltImageSrc: woltImage,
    foodpandaImageSrc: foodpandaImage,
    falatozzImageSrc: falatozzImage,
    choiceqrImageSrc: choiceqrImage,
    minimumPrice,
    allergens,
    removable_allergens,
    calorie,
    approvedCost
  }).done(function (data) {
    auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
    resultHandler(data, handler, errorHandler);
  });
}
utils.addMenuItem = addMenuItem;

function modifyMenuCategory(
  {
    id,
    globalId,
    name,
    description,
    image,
    timing,
    productionLines,
    vatCategory,
    takeawayVatCategory,
    isActive,
    isTop,
    pos,
    kiosk,
    above18,
    online,
    local,
    takeaway,
    available,
    inventoryItem,
    menuItemAdditions,
    menuCategoryAdditions,
    labels,
    pricePerCostRatio,
    color,
    settings,
    fromDate,
    toDate,
    preorder,
    mainCategory,
    subCategory,
    mainCategoryId,
    subCategoryId,
    allergens,
    removable_allergens

  },
  handler,
  errorHandler
) {
  var production_lines_q = "";
  productionLines.forEach(function (pl) {
    production_lines_q += "&productionLineId=" + (pl.id ? pl.id : pl);
  });
  menuItemAdditions && menuItemAdditions.forEach(function (a) {
    if (a.type == "meal_addition") a.addition.type = "meal";
    else a.addition.type = "drink";
  });
  menuCategoryAdditions && menuCategoryAdditions.forEach(function (a) {
    if (a.type == "mealcategory_addition") a.addition.type = "mealcategory";
    else a.addition.type = "drinkcategory";
  });
  vatCategory = vatCategory && vatCategory.id ? vatCategory.id : 0;
  takeawayVatCategory = takeawayVatCategory && takeawayVatCategory.id ? takeawayVatCategory.id : 0;
  var entityType = getMenuCategoryAdmin(id).entityType;
  post("adminService/" + localStorage.restaurantSelected + "/modify" + entityType + "/" + id + "?" + production_lines_q + "&vatCategoryId=" + vatCategory + "&takeawayVatCategoryId=" + takeawayVatCategory, {
    type: entityType.toLowerCase(),
    id: id,
    globalId,
    name: name,
    description: description,
    imageSrc: image,
    timing: timing,
    isActive: isActive,
    isTop: isTop,
    pos,
    kiosk: kiosk,
    above18,
    online: online,
    local,
    takeaway,
    available: available,
    inventoryItem: inventoryItem,
    menuItemAdditions: menuItemAdditions,
    menuCategoryAdditions: menuCategoryAdditions,
    labels: labels,
    pricePerCostRatio: pricePerCostRatio,
    color: color,
    settings: settings,
    fromDate,
    toDate,
    preorder,
    mainCategory: mainCategory === undefined ? mainCategoryId : mainCategory,
    subCategory: subCategory === undefined ? subCategoryId : subCategory,
    allergens,
    removable_allergens
  }).done(function (data) {
    auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
    resultHandler(data, handler, errorHandler);
  });
}
utils.modifyMenuCategory = modifyMenuCategory;

function approveCostChange(id, handler, errorHandler) {
  get("orderService/" + localStorage.restaurantSelected + "/approveCostChange/" + id).done(function (data) {
    auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
    resultHandler(data, handler, errorHandler);
  });
}
utils.approveCostChange = approveCostChange;

function updateMenuItemOrders(ids, handler, errorHandler) {
  post("adminService/" + localStorage.restaurantSelected + "/update" + menuitemutil.entityType + "CategoryOrders", ids, undefined, undefined, 2, undefined, 60000).done(function (data) {
    resultHandler(data, handler, errorHandler);
  });
}
utils.updateMenuItemOrders = updateMenuItemOrders;

function addMenuCategory(
  parentCategoryId,
  {
    globalId,
    name,
    description,
    image,
    timing,
    productionLines,
    vatCategory,
    takeawayVatCategory,
    local,
    takeaway,
    isActive,
    isTop,
    pos,
    kiosk,
    above18,
    online,
    available,
    inventoryItem,
    menuItemAdditions,
    menuCategoryAdditions,
    labels,
    pricePerCostRatio,
    color,
    settings,
    fromDate,
    toDate,
    preorder,
    mainCategory,
    subCategory,
    allergens,
    removable_allergens
  },
  handler,
  errorHandler
) {
  var production_lines_q = "";
  productionLines.forEach(function (pl) {
    production_lines_q += "&productionLineId=" + (pl.id ? pl.id : pl);
  });
  takeawayVatCategory = takeawayVatCategory && takeawayVatCategory.id ? takeawayVatCategory.id : 0;
  vatCategory = vatCategory && vatCategory.id ? vatCategory.id : 0;
  post("adminService/" + localStorage.restaurantSelected + "/add" + menuitemutil.entityType + "Category/" + parentCategoryId + "?" + production_lines_q + "&vatCategoryId=" + vatCategory + "&takeawayVatCategoryId=" + takeawayVatCategory, {
    globalId,
    type: menuitemutil.entitytype + "category",
    name: name,
    description: description,
    imageSrc: image,
    timing: timing,
    isActive: isActive,
    local,
    takeaway,
    isTop: isTop,
    pos,
    kiosk: kiosk,
    above18,
    online: online,
    available: available,
    inventoryItem: inventoryItem,
    menuItemAdditions: menuItemAdditions,
    menuCategoryAdditions: menuCategoryAdditions,
    labels: labels,
    pricePerCostRatio: pricePerCostRatio,
    color: color,
    settings: settings,
    fromDate,
    toDate,
    preorder,
    mainCategory,
    subCategory,
    allergens,
    removable_allergens
  }).done(function (data) {
    auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
    resultHandler(data, handler, errorHandler);
  });
}
utils.addMenuCategory = addMenuCategory;

utils.deleteMenuCategory = function (id, handler, errorHandler) {
  var entityType = getMenuCategoryAdmin(id).entityType;
  confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.do_you_really_want_to_delete_the_menu_category")).done(function () {
    get("adminService/" + localStorage.restaurantSelected + "/delete" + entityType + "/" + id).done(function (data) {
      auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
      resultHandler(data, handler, errorHandler);
    });
  });
};

utils.deleteMenuItem = function (id, handler, errorHandler) {
  var entityType = getMenuItemAdmin(id).entityType;
  confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.do_you_really_want_to_delete_the_menu_item")).done(function () {
    get("adminService/" + localStorage.restaurantSelected + "/delete" + entityType + "/" + id).done(function (data) {
      auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
      resultHandler(data, handler, errorHandler);
    });
  });
};

function setMenuItemParentCategory(id, parentCategoryId, handler, errorHandler) {
  get("adminService/" + localStorage.restaurantSelected + "/set" + menuitemutil.entityType + "ParentCategory/" + id + "?parentCategoryId=" + parentCategoryId).done(function (data) {
    auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
    resultHandler(data, handler, errorHandler);
  });
}
utils.setMenuItemParentCategory = setMenuItemParentCategory;

function setMenuCategoryParentCategory(id, parentCategoryId, handler, errorHandler) {
  get("adminService/" + localStorage.restaurantSelected + "/set" + menuitemutil.entityType + "CategoryParentCategory/" + id + "?parentCategoryId=" + parentCategoryId).done(function (data) {
    auth.myStatus.restaurant_modification_timestamp = new Date().getTime();
    resultHandler(data, handler, errorHandler);
  });
}
utils.setMenuCategoryParentCategory = setMenuCategoryParentCategory;

utils.getMenuCategoryProperty = function (id, property) {
  var image = utils._getMenuItemCategoryProperty(id, admin.categories.activeMenuCategories ? admin.categories.activeMenuCategories : admin.categories.children, property);
  if (image == "") {
    return null;
  }
  return image;
};

utils._getMenuItemCategoryProperty = function (id, categories, property) {
  var val = null;
  categories.forEach(function (menuCategory) {
    if (menuCategory.entityType != menuitemutil.entityType || val != null) return;
    if (menuCategory.id == id) {
      if (menuCategory[property] != "") val = menuCategory[property];
      else val = "";
    } else {
      if (menuCategory.activeMenuCategories && menuCategory.activeMenuCategories.length > 0) val = utils._getMenuItemCategoryProperty(id, menuCategory.activeMenuCategories, property);
      else if (menuCategory.children && menuCategory.children.length > 0) val = utils._getMenuItemCategoryProperty(id, menuCategory.children, property);
    }
  });
  return val;
};

utils.downloadMenuItems = (handler) => {
  get("restaurantService/" + localStorage.restaurantSelected + "/download" + menuitemutil.entityType + "s", localStorage.restaurantSelected).
    done(function (data) {
      if (data == null) {
        console.log("Failed to get categories!");
      } else {
        handler(data);
      }
    });
}


export default utils;
